import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import {
  NgbModal,
  NgbModalRef
} from "@ng-bootstrap/ng-bootstrap";
import { NotificationService } from "../shared/services/notification.service";
import { AccountService } from "../shared/account/account.service";
import { Observable } from "rxjs/Observable";
import { LoaderService } from "../shared/services/loader.service";
import { Constants } from "../helper/constants";

@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.css"]
})
export class NotificationsComponent implements OnInit {
  activeRouteIndex: number;
  routeSubscription: Subscription;
  notification;
  userId: string;
  notifications;
  modalReference: NgbModalRef;
  communityId: string;

  /**
   *
   * @param {Router} router
   * @param {AccountService} accountService
   * @param {ActivatedRoute} route
   * @param {LoaderService} loaderService
   * @param {NgbModal} modalService
   * @param {NotificationService} notificationService
   */
  constructor(
    private router: Router,
    private accountService: AccountService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private modalService: NgbModal,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    let done = false;
    this.userId = this.accountService.getUserId();
    this.routeSubscription = this.route.params.subscribe(params => {
      this.activeRouteIndex = parseInt(params.index, 10);
      this.accountService.getProfile(this.userId).subscribe((profile: any) => {
        const role: any = profile.roles[this.activeRouteIndex];
        this.communityId = role.communityId;
        if (!done) {
          this.notificationService.getNotifications(this.communityId, profile.id)
          .subscribe(data => this.notifications = this.sortNotifications(data));
          done = true;
        }
      });
    });
  }

  viewNotification(index, notification, modal): Promise<void> {
    this.notification = notification;
    const billTypeCanBeVisited = notification.type === Constants.BILL_TYPE_NOTIFICATION
      && (notification.action === Constants.ENABLE || notification.action === Constants.UPDATE);

    if (!notification.isRead && notification.id) {
        this.notificationService.markNotificationAsRead(this.communityId, notification.id, this.userId);
      }

    if (billTypeCanBeVisited) {
      this.router.navigate([`bill-types/r/${this.activeRouteIndex}/${this.communityId}/${notification.entityId}/setup`]);

      return ;
    } else {
      const promise = new Promise(resolve => {
        if (notification.type === Constants.PAYMENT_NOTIFICATION) {
          this.router.navigate([`payments/r/${this.activeRouteIndex}`]);
          resolve(true);
        } else {
          resolve(false);
        }
      });

      return promise.then(() => this.open(modal));
    }
  }

  open(modal): void {
    this.modalReference = this.modalService.open(modal);
  }

  close(): void {
    this.modalReference.close();
  }

  sortNotifications(notifications): any {
    notifications = notifications.sort((a, b) => {
        return ((new Date(b["date"])as any) / 1000) - ((new Date(a["date"])as any) / 1000) ;
      });

    return notifications;
    }

}



// WEBPACK FOOTER //
// ./src/app/notifications/notifications.component.ts